import { useRef } from "react";
import {
  validateNationalIdNumber,
  ValidateResponse,
} from "./validateNationalIdNumber";
import { assertNotNull } from "cy-util";

export const useSaNationalIdValidator = () => {
  const validationStatusRef = useRef<ValidateResponse | undefined>(undefined);

  function validate({ id, minAge = 18 }: { id: string; minAge?: number }) {
    validationStatusRef.current = validateNationalIdNumber({
      number: id || "",
      minAge,
    });
    return validationStatusRef.current;
  }

  function createCallbacks({
    trigger,
    setGender,
    setDateOfBirth,
  }: {
    trigger: (
      name: "nationalId" | "gender" | "dateOfBirth",
    ) => Promise<unknown>;
    setDateOfBirth: ({
      date,
      day,
      month,
      year,
    }: {
      date: string;
      day: number;
      month: number;
      year: number;
    }) => void;
    setGender: (gender: "Male" | "Female") => void;
    hasValidationError: boolean;
  }) {
    const onBlur = () => {
      (async () => {
        await trigger("nationalId");
        if (validationStatusRef.current && !validationStatusRef.current.error) {
          switch (validationStatusRef.current.gender) {
            case "male":
              setGender("Male");
              break;
            case "female":
              setGender("Female");
              break;
            default:
              break;
          }
          const date = assertNotNull(validationStatusRef.current.dob);
          const parts = date.split("-");
          if (parts.length === 3) {
            setDateOfBirth({
              date,
              day: parseInt(parts[2]),
              month: parseInt(parts[1]),
              year: parseInt(parts[0]),
            });
          }
          await trigger("gender");
          await trigger("dateOfBirth");
        }
      })().catch((err) => console.error(err));
    };
    function onValidate(id: string | undefined) {
      const status = validate({
        id: id || "",
      });
      if (status.error) {
        return "Invalid Id";
      }
      return true;
    }
    return { onBlur, validate: onValidate };
  }
  return { validationStatusRef, validate, createCallbacks };
};
